import OrderItem from '../components/OrderItem/OrderItem';

const OrderDetail = () => <OrderItem />;

export default OrderDetail;
